import qs from 'qs'
import axios from '@/api/apiClient'
import { deepClone } from '@/utils/util'

/**
 * 名片api
 * @doc https://www.tapd.cn/38059561/markdown_wikis/show/#1138059561001000389
 */
const api = {
  // 我的名片
  statisticsData: '/api/member/mycard/myCardCount',
  viewData: '/api/member/mycard/viewMemberList',
  myMemberCardRecommend: '/api/member/mycard/recommend',
  swapCard: '/api/member/myexchangecard/exchange',
  // 名片数据
  DataList: '/api/myMemberCardCloudSystemLog/page',
  ownForwardList: '/api/myMemberCardCloudSystemLog/detail/ownForward/page',
  // 原本的客户数据, 现在的员工个人接口
  DataDashboard: '/api/myMemberCardCloudSystemLog/statistics',
  DataAnalyse: '/api/myMemberCardCloudSystemLog/allCount',
  DataDetail: '/api/myMemberCardCloudSystemLog/detail/member',
  DataDetailList: '/api/myMemberCardCloudSystemLog/detail/page',
  // 子账号用户信息
  subMemberInfo: '/api/myMemberCardCloudSystemLog/detail/subMember',
  // 名片夹
  FolderList: '/api/member/mycard/list',
  VipBalance: '/api/member/mycard/vip/balance',
  // 查看主账号名片信息
  primaryAccount: '/api/member/card/primary-account',
}
export default api
// 修改推荐列表内容
export const postMyMemberCardRecommend = (params) => {
  return axios.$post(`${api.myMemberCardRecommend}`, params)
}

/**
 * 更新名片信息
 * @param {String} param.contact 联系人
 * @param {String} param.phone 手机号
 * @param {String} param.email    邮箱
 * @param {String} param.fixedphone 固话
 * @param {String} param.post 岗位
 */
export const postUpdateCard = (param) => {
  const params = deepClone(param)
  return axios.$post('/api/member/mycard/lang/update', params)
}

/**
 * 我的我的名片-名片推荐栏隐藏、展示状态切换
 * @param {*} key 取memberCardRecommends.recommendType字段
 * @param {*} showFlag 是否展示（0-否,1-是）
 * @returns
 */
export const switchRecommendShow = (param) => {
  return axios.$put('/api/member/mycard/recommend/switch', param)
}

// 获取我的名片信息
export const getMyMemberCard = () => {
  return axios.$get('/api/member/mycard/info/lang')
}
/**
 * 获取名片统计数据
 */
export const getStatisticsData = () => {
  return axios.$get(`${api.statisticsData}`)
}
/**
 * 我的名片点赞用户列表
 */
export const getViewData = () => {
  return axios.$get(`${api.viewData}`)
}

/**
 * 交换云展
 * @param {*} query.memberUnicode 对方会员code
 */
export const getSwapCard = (query) => {
  return axios.$get(`${api.swapCard}${query ? `?${qs.stringify(query)}` : ''}`)
}

/**
 * 名片数据列表
 * @param {Number} query.type 类型;1:被查看;2:被转发;3:点赞；4：主动分享
 * @param {String} query.viewMemberName 查看者用户名
 * @param {String} query.subMemberCode 子账号code
 * @param {Number} query.current 页码
 * @param {Number} query.size 页容量
 */
export const getDataList = (query) => {
  return axios.$get(`${api.DataList}${query ? `?${qs.stringify(query)}` : ''}`)
}

/***
 * 我的分享列表
 * @param {Number} query.current 页码
 * @param {Number} query.size 页容量
 */
export const getOwnForwardList = (query) => {
  return axios.$get(`${api.ownForwardList}${query ? `?${qs.stringify(query)}` : ''}`)
}

/**
 * 名片数据 统计面板
 */
export const getDataDashboard = () => {
  return axios.$get(`${api.DataDashboard}`)
}

/**
 * 2.2.6 我的客户数据
 * @returns
 */
export const getDataDashboardV2 = (query) => {
  return axios.$get(`/api/myMemberCardCloudSystemLog/statisticspc${query ? `?${qs.stringify(query)}` : ''}`)
}

export const getDataDashboardV2Chat = (query) => {
  return axios.$get(`/api/myMemberCardCloudSystemLog/statisticspc/chart${query ? `?${qs.stringify(query)}` : ''}`)
}

/** 2.2.6 客户数据 */
export const getCustomerData = (query) => {
  return axios.$get(`/api/myMemberCardCloudSystemLog/customerData${query ? `?${qs.stringify(query)}` : ''}`)
}

/** 2.2.6 客户数据 折线图 */
export const getCustomerDataChat = (query) => {
  return axios.$get(`/api/myMemberCardCloudSystemLog/customerData/chart${query ? `?${qs.stringify(query)}` : ''}`)
}

/**
 * 2.2.6 企业数据
 * @returns
 */
export const getCompanyData = (query) => {
  return axios.$get(`/api/myMemberCardCloudSystemLog/statisticsByDate${query ? `?${qs.stringify(query)}` : ''}`)
}

/**
 * 2.2.6 客户管理
 */
export const getCustomerManage = (query) => {
  return axios.$get(`/api/myMemberCardCloudSystemLog/customerManagement${query ? `?${qs.stringify(query)}` : ''}`)
}

/**
 * 2.2.6 客户管理-折线图
 */
export const getCustomerManageChat = (query) => {
  return axios.$get(`/api/myMemberCardCloudSystemLog/customerManagement/chart${query ? `?${qs.stringify(query)}` : ''}`)
}

/**
 * 名片详细数据分析
 * @param {Number} query.type 1:被查看;2:被转发;3:点赞；4：主动分享
 * @param {Number} query.timeType 1昨日;2近7日;3近30日;0所有
 * @param {Number} query.id 查看详情ID
 */
export const getDataAnalyse = (query) => {
  return axios.$get(`${api.DataAnalyse}${query ? `?${qs.stringify(query)}` : ''}`)
}

/**
 * 名片数据详情用户信息
 * @param {*} id id
 */
export const getDataDetail = (id, query) => {
  return axios.$get(`${api.DataDetail}/${id}${query ? `?${qs.stringify(query)}` : ''}`)
}

/**
 * 名片数据详情列表
 * @param {*} id id
 * @param {Number} query.current 页码
 * @param {Number} query.size 页容量
 */
export const getDataDetailList = (id, query) => {
  return axios.$get(`${api.DataDetailList}/${id}${query ? `?${qs.stringify(query)}` : ''}`)
}

export const newGetDataDetailList = (query) => {
  return axios.$get(`${api.DataDetailList}${query ? `?${qs.stringify(query)}` : ''}`)
}

/**
 * 名片夹列表
 * @param {Number} query.title 公司名/姓名
 * @param {Number} query.current 页码
 * @param {Number} query.size 页容量
 */
export const getFolderList = (query) => {
  return axios.$get(`${api.FolderList}${query ? `?${qs.stringify(query)}` : ''}`)
}

/**
 * 子账号用户信息
 * @param {String} subMemberCode 子账号code
 */
export const getSubMemberInfo = (subMemberCode, query) => {
  return axios.$get(`${api.subMemberInfo}/${subMemberCode}${query ? `?${qs.stringify(query)}` : ''}`)
}

/**
 * 名片夹详情
 */

export const getVipBalance = (query) => {
  return axios.$get(`${api.VipBalance}${query ? `?${qs.stringify(query)}` : ''}`)
}
export const getPrimaryAccount = (memunicode, query) => {
  return axios.$get(`${api.primaryAccount}${query ? `?${qs.stringify(query)}` : ''}`)
}

// 名片通讯录 群组列表
export const addressBookGroupingList = () => {
  const query = {
    size: 999,
    current: 1,
  }
  return axios.$get(`/api/card/group/page${query ? `?${qs.stringify(query)}` : ''}`)
}

// 新增分组
export const addressBookGroupingAdd = (param) => {
  return axios.$post('/api/card/group/save', param)
}

// 分组下的卡片列表
export const getGroupCardList = (query) => {
  return axios.$get(`/api/member/mycard/list${query ? `?${qs.stringify(query)}` : ''}`)
}

// 删除群组
export const deleteGroup = (groupId) => {
  // { params: { removeAllFlag: removeAllFlag ? 1 : 0 } }
  return axios.$delete(`/api/card/group/${groupId}`)
}

// 根据id获取群组信息
export const getGroupInfo = (groupId) => {
  return axios.$get(`/api/card/group/review/${groupId}`)
}

// 编辑分组
export const addressBookGroupingEdit = (param, groupId) => {
  return axios.$put(`/api/card/group/${groupId}`, param)
}
// 批量移除分组中名片
export const deleteGroupCards = (data) => {
  return axios.$post('/api/card/group/cardsBatch', data)
}
// 添加名片到某个分组
export const addcardtoGroup = (param) => {
  return axios.$post('/api/card/group/cards', param)
}

// 名片详情
export const getMemberCardInfo = (unicode) => {
  return axios.$get(`api/member/card/info/${unicode}`)
}

export const focusOnUsers = (data) => {
  return axios.$post('/api/member/myFocus/person/changeFocus', null, { params: data })
}

// 名片落地页 浏览用户、浏览数、点赞数
export const getMemberCardStatisticInfo = (memunicode) => {
  return axios.$get('/api/member/card/viewMemberList', { params: { memunicode } })
}

// 名片点赞
export const businessCard = (memunicode) => {
  return axios.$post('/api/member/card/like', {
    memunicode,
  })
}

// 个人动态点赞
export const personalDynamicLike = ({ id }) => {
  return axios.$get('/api/member/card/like', { params: { dynamicId: id } })
}

/**
 * 校验企业是否存在或者正在申请, 企业云展览用
 * //0:未创建企业、未申请中、未申请成为子账号 * //1:已存在企业-直接跳转企业云展 * //2:已在申请企业认证 * //3:已在申请成为某企业子账号
 */
export const checkCompanyExist = (query) => {
  return axios.$get(`/api/company/info/checkCompanyStatus${query ? `?${qs.stringify(query)}` : ''}`)
}

/**
 * 根据当前语言环境，判断该企业名是否已被注册
exists ：0-企业名未被注册，1-企业名已被注册
companyCode：企业code
address：地址
 * @param {*} data 
 * @returns 
 */
export const checkCompanyName = (query) => {
  return axios.$get(`/api/company/info/exists${query ? `?${qs.stringify(query)}` : ''}`)
}

// 新用户创建名片同时创建企业
export const createCompany = (data) => {
  return axios.$post('/api/company/info/create', data)
}

// 客户踪迹
export const getCustomerTrack = (query) => {
  return axios.$get(`/api/myMemberCardCloudSystemLog/detail/page/v2${query ? `?${qs.stringify(query)}` : ''}`)
}

// 关注的企业
export const getFocusCompany = (query) => {
  return axios.$get(`/api/member/myFocus/company/page${query ? `?${qs.stringify(query)}` : ''}`)
}
